export const TIPOS_GRAVIDEZ = [{
  text: 'Selecione',
  value: '',
}, {
  text: 'Ignorado',
  value: 'IGNORADO',
}, {
  text: 'Única',
  value: 'UNICA',
}, {
  text: 'Dupla',
  value: 'DUPLA',
}, {
  text: 'Tripla ou mais',
  value: 'TRIPLA',
}]

export const TIPOS_PARTO = [{
  text: 'Selecione',
  value: '',
}, {
  text: 'Ignorado',
  value: 'Ignorado',
}, {
  text: 'Vaginal',
  value: 'Vaginal',
}, {
  text: 'Cesáreo',
  value: 'Cesáreo',
}]
